import { Input, InputNumber, Select } from "antd";
import TextArea from "antd/es/input/TextArea";
import Text from "antd/es/typography/Text";
import { DropPeriod } from "../../../api";
import { useAppSelector } from "../../../app/hooks";
import { EntityColumns } from "../../../app/types";
import { selectInfluenceObject } from "../../influenceObjects/InfluenceObjectsSlice";
import { selectOrganizationModulePeriod } from "../../organizationModule/OrganizationModuleSlice";

export const DropPeriodColumns = (): EntityColumns<DropPeriod>[] => {
  const period = useAppSelector(selectOrganizationModulePeriod);
  const influenceObjects = useAppSelector(selectInfluenceObject);

  return [
    {
      title: "Объект воздействия",
      dataIndex: "influenceObject",
      key: "influenceObjectId",
      inputNode: <Select
        showSearch
        filterOption={(input, option) => {
          if (option) {
            return (
              option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
          } else {
            return true;
          }
        }}
        options={influenceObjects?.map(
          (influenceObject) => {
            return {
              value: influenceObject.id,
              label: influenceObject.name
            }
          }
        )} />,
      render: (obj) => <Text className="w-64" ellipsis={{ tooltip: `${influenceObjects?.find((influenceObject) => influenceObject.id === obj)?.name}` }}>{influenceObjects?.find((influenceObject) => influenceObject.id === obj)?.name}</Text>,
      rules: [{ required: true, message: "Заполните поле" }],
      editable: true,
      copyable: true,
    },
    {
      title: "Объем сброса, м3",
      dataIndex: "dropVolumeM3",
      key: "dropVolumeM3",
      inputNode: <InputNumber style={{ width: '100%' }} />,
      rules: [{ required: true, message: "Заполните поле" }],
      editable: true,
      copyable: true,
    },
    {
      title: "Квартал",
      dataIndex: "quarter",
      key: "quarter",
      inputNode: <Input defaultValue={period.quarter} style={{ width: '100%' }} disabled={true} />,
      rules: [{ required: false, message: "Заполните поле" }],
      editable: false,
      copyable: false,
    },
    {
      title: "Год",
      dataIndex: "year",
      key: "year",
      inputNode: <Input defaultValue={period.year} style={{ width: '100%' }} disabled={true} />,
      rules: [{ required: false, message: "Заполните поле" }],
      editable: false,
      copyable: false,
    },
    {
      title: "Комментарии",
      dataIndex: "comment",
      key: "comment",
      inputNode: <TextArea />,
      render: (text) => <Text className="w-64" ellipsis={{ tooltip: text }}>{text}</Text>,
      editable: true,
      copyable: true,
    },
  ]
}
